<template>
  <section class="password-generator inverse bg-white">
    <PasswordGenerator :showAfterTimeout="showAfterTimeout" @generated="onGenerated"></PasswordGenerator>
  </section>
</template>

<script>
import PasswordGenerator from '../components/PasswordGenerator.vue'

export default {
  name: 'GeneratorSection',
  components: {
    PasswordGenerator
  },
  data () {
    return {
      showAfterTimeout: false
    }
  },
  methods: {
    onGenerated () {
      this.showAfterTimeout = true
    }
  }
}
</script>

<style>

section.password-generator {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

#pwd-copy-btn {
  display: flex;
  align-items: center;
  background-color: #008941;
  color: #FFF;
  border-radius: 5px;
  padding: 18px 43px;
  font-size: 18px;
  font-weight: 700;
  height: 56px;
  cursor: pointer;
  text-decoration: none;
}

@media only screen and (max-width: 600px) {
  section.password-generator {
    padding: 48px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/GeneratorSection.vue